// extracted by mini-css-extract-plugin
export var checkbox = "styles-module--checkbox--d2eb5";
export var checkboxWrapper = "styles-module--checkboxWrapper--85b36";
export var container = "styles-module--container--e8c1e";
export var currentSpots = "styles-module--currentSpots--2a3da";
export var description = "styles-module--description--cba89";
export var done = "styles-module--done--887ef";
export var form = "styles-module--form--7e4d2";
export var iconsContainer = "styles-module--iconsContainer--59be6";
export var imageWrapper = "styles-module--imageWrapper--a08ce";
export var inputContainer = "styles-module--inputContainer--783cf";
export var progress = "styles-module--progress--cc42d";
export var progressContainer = "styles-module--progressContainer--99610";
export var progressWrapper = "styles-module--progressWrapper--ace93";
export var remainingSpots = "styles-module--remainingSpots--0e168";
export var signUpBtn = "styles-module--signUpBtn--c8aa1";
export var socialWrapper = "styles-module--socialWrapper--70cde";
export var spotsContainer = "styles-module--spotsContainer--c2387";
export var success = "styles-module--success--b13f0";
export var successTitle = "styles-module--successTitle--173b8";
export var title = "styles-module--title--4a701";
export var waitList = "styles-module--waitList--17972";